import { MdOutlineFileDownload } from "react-icons/md";
import "../AcademicCalendar/CalendarBtn.scss";

const DownloadBtn = ({ year, fileData, contentType, btnName, titleFontSize, yearFontSize }) => {

    const handleDownload = () => {
        const byteCharacters = atob(fileData);
        const byteNumbers = Array.from(byteCharacters, char => char.charCodeAt(0));
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: contentType });
        const fileUrl = URL.createObjectURL(blob);
        const newWindow = window.open(fileUrl, '_blank');
        if (!newWindow) {
            alert("Please allow pop-ups for this site.");
        }
    };

    return (
        <button className="downloadBtnParent1" onClick={handleDownload}>
            <div>
                <span>
                    <MdOutlineFileDownload size="1.8rem" />
                </span>
            </div>
            <div>
                {btnName && (<span style={{ fontSize: `${titleFontSize}rem` }} className="btnName">{btnName}</span>)}
                {year && (<span style={{ fontSize: `${yearFontSize}rem` }} className="years">{year}</span>)}
            </div>
        </button>
    );
};

export default DownloadBtn;

